const logoLightMode = require("@/assets/logo/pafm_borderless_black.svg");
const logoDarkMode = require("@/assets/logo/pafm_borderless_white.svg");

export default {
  props: {
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logo() {
      if (this.darkMode) {
        return logoDarkMode;
      }

      return logoLightMode;
    },
  },
};
